export default class ShippingClient {
  constructor({ url, _get, _post }) {
    this.url = url
    this.get = _get
    this.post = _post
  }

  help() {
    console.log('getNonce(address)')
    console.log('save(info)')
  }

  new() {
    return {
      order_id: null,
      email: '',
      eth_address: '',
      txn_hash: '',
      signed_message: ''
    }
  }

  async getNonce(address) {
    const fallback = { nonce: null }
    const url = `${this.url}/api/v1/shipping/${address}/nonce`
    const { nonce } = await this.get(url, null, fallback)

    return nonce
  }

  async save(info) {
    const fallback = this.new()
    const url = `${this.url}/api/v1/shipping/${info.eth_address}/info`
    const order = await this.post(url, null, info, fallback)

    return order
  }
}
